import React, { useState, useCallback, useEffect } from "react";
import {
  Select,
  Card,
  PageActions,
  Text,
  Loading,
  Button,
  Page,
  InlineError,
  FormLayout,
  Spinner,
  Toast,
} from "@shopify/polaris";
import axios from "axios";
const DeployNetlify = () => {
  const [isDeploying, setIsDeploying] = useState(false);
  return (
    <Page>
      <Card sectioned>
        <Button
          primary
          loading={isDeploying}
          onClick={() => {
            setIsDeploying(true);
            axios
              .post(
                `https://api.netlify.com/build_hooks/${process.env.REACT_APP_DEPLOY_ID}`
              )
              .then((res) => {
                setIsDeploying(false);
                //toggleActive();
              })
              .catch((err) => console.log(""));
          }}
        >
          Publish
        </Button>
      </Card>
    </Page>
  );
};

export default DeployNetlify;
